// src/redux/store.js
import { configureStore } from "@reduxjs/toolkit";

// === Slice Imports ===
import authReducer from "./slices/authSlice";
// import temperatureReducer from "./slices/TemperatureSlice";
import activityReducer from "./slices/ActivitySlice";
import usersReducer from "./slices/UsersSlice";
import adminReducer from "./slices/AdminSlice";
import deviceReducer from "./slices/DeviceSlice";
import activityTrackReducer from "./slices/ActivityTrackSlice";
import notificationReducer from "./slices/NotificationSlice";
import patientsReducer from "./slices/PatientSlice"; // ✅ PatientSlice included
import alertReducer from "./slices/AlertSlice"; // ✅ AlertSlice included
import temperatureReducer from "./slices/temperatureSlice";
import heartRateReducer from "./slices/heartRateSlice";
import spo2Reducer from "./slices/spo2Slice";
import batteryReducer from "./slices/batterySlice";
import stepsReducer from "./slices/stepsSlice";

// === Configure Store ===
const store = configureStore({
  reducer: {
    auth: authReducer,
    // temperature: temperatureReducer,
    activity: activityReducer,
    users: usersReducer,
    admins: adminReducer,
    devices: deviceReducer,
    activityTrack: activityTrackReducer,
    notifications: notificationReducer,
    patients: patientsReducer, // ✅ Added to reducer map
    alerts: alertReducer, // ✅ Added to reducer map
    temperature: temperatureReducer,
    heartRate: heartRateReducer,
    spo2: spo2Reducer,
    battery: batteryReducer,
    steps: stepsReducer,
  },
});

export default store;
